module.exports = __webpack_public_path__ + "static/img/GrowthEmployee.757e638.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/images/whoweare/GrowthEmployee.png
// module id = atrM
// module chunks = 1